
export const formatChartDate = (dateInput, { showYear = false, yearOnly = false } = {}) => {
  if (!dateInput) return '';
  const date = new Date(dateInput);
  if (isNaN(date)) return String(dateInput);

  if (yearOnly) {
    return date.getFullYear().toString();
  }

  const options = showYear
    ? { day: 'numeric', month: 'short', year: 'numeric' }
    : { day: 'numeric', month: 'short' };

  return date.toLocaleDateString('en-GB', options);
};


export const prepareChartData = (data, valueKey = 'count') => {
  if (!Array.isArray(data) || data.length === 0) return [];

  const sorted = data
    .map(item => ({
      rawDate: item?.due_date,
      [valueKey]: parseInt(item?.[valueKey], 10) || 0,
    }))
    .sort((a, b) => new Date(a.rawDate) - new Date(b.rawDate));

  const firstYear = new Date(sorted[0].rawDate).getFullYear();
  const hasMultipleYears = sorted.some(d => new Date(d.rawDate).getFullYear() !== firstYear);

  // Check if all are Jan 1 → show only year
  const allAreJanFirst = sorted.every(d => {
    const dt = new Date(d.rawDate);
    return dt.getDate() === 1 && dt.getMonth() === 0;
  });

  return sorted.map(item => ({
    name: formatChartDate(item.rawDate, { showYear: hasMultipleYears, yearOnly: allAreJanFirst }),
    [valueKey]: item[valueKey],
  }));
};
